import { Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ShIconModule } from '../../../../../elements/public_api';
import { ShBaseCell } from '../_base/base-cell.component';
import { BooleanCell } from './boolean-cell.entity';
import { booleanToIcon } from './boolean-to-string-icon.helper';

@Component({
    standalone: true,
    selector: 'sh-boolean-cell',
    templateUrl: './boolean-cell.component.html',
    imports: [CommonModule, ShIconModule]
})
export class ShBooleanCellComponent extends ShBaseCell {
    @Input() public cell!: BooleanCell;

    get icon(): string {
        return booleanToIcon(this.cell.value ?? false);
    }
}
